import React from "react";

const StepLegacyStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0595 4.75H4.94048C4.283 4.75 3.75 5.0742 3.75 5.47414V14.5259C3.75 14.9258 4.283 15.25 4.94048 15.25H15.0595C15.717 15.25 16.25 14.9258 16.25 14.5259V5.47414C16.25 5.07421 15.717 4.75 15.0595 4.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StepLegacyStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;